import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../lib/api';

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await api.getCountries();
        setCountries(Array.isArray(data) ? data : []);
        if (!Array.isArray(data)) {
          console.error('Countries API returned a non-array response:', data);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const value = {
    countries,
    selectedCountry,
    setSelectedCountry,
    loading,
    getCountryName: (code) => {
      const country = countries.find(c => c.code === code);
      return country?.name || code;
    },
    getCountryCurrency: (code) => {
      const country = countries.find(c => c.code === code);
      return country?.currency || 'EUR';
    },
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within CountryProvider');
  }
  return context;
}
